//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InfoIcon from '~/assets/svg/icon-info.svg?inline';
export default {
  components: {
    InfoIcon,
  },
};
